import { useEffect } from 'react';
import KiosekService from '../api/JsdhNotifikaceService/service/KiosekService';

export const INTERVAL_KIOSEK_ZIJE_MS = 120_000;

/**
 * Kiosková stránka hlásí backendu, že běží (spec upozornění na odpojení 5.1): hned po načtení a pak každé 2 minuty.
 * Jen s device tokenem (stránku /poplach používají i přihlášení uživatelé bez tokenu) a ne v mock režimu.
 * Chyba signálu (401, 403, síť) se jen spolkne, další pokus přijde za 2 minuty.
 */
export const useKiosekZije = (deviceToken: string | null | undefined, aktivni: boolean): void => {
    useEffect(() => {
        if (!deviceToken || !aktivni) {
            return undefined;
        }
        const posli = () => {
            KiosekService.kiosekZije(deviceToken).catch(() => undefined);
        };
        posli();
        const id = window.setInterval(posli, INTERVAL_KIOSEK_ZIJE_MS);
        return () => window.clearInterval(id);
    }, [deviceToken, aktivni]);
};
